<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div>
          <div class="page text-white">Course Management</div>
          <lms-button
            color="#fff"
            @click="$router.push({ name: 'tenant-create-course' })"
            >Add Course</lms-button
          >
        </div>
        <div>
          <img :src="require('../../../assets/tenant_image.png')" alt="" />
        </div>
      </div>
    </lcontainer>

    <lcontainer>
      <div class="flex justify-between">
        <page-header class="py-2 tenant-main-color">Courses</page-header>
        <div class="flex m-2">
          <div class="filter-sort flex items-center">
            <div class="sort ml-12 flex items-center">
              <i class="text-gray-500 fas fa-sort-amount-up"></i>
              <span class="font-semibold mr-3 ml-2">Sort By: </span>
              <div class="relative">
                <select
                  v-model="selection"
                  class="w-32 block appearance-none bg-gray-200 border border-gray-200 text-gray-700 py-2 px-4 pr-8 rounded-full leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                  id="grid-state"
                >
                  <option selected>published</option>
                  <option>drafted</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mx-4" />
      <div class="mx-8 mt-4">
        <linput
          v-model="search"
          class="py-2"
          placeholder="Search by Course Name"
        />
      </div>
      <div />
      <div class="flex flex-wrap" v-if="selection === 'published'">
        <div
          v-for="(course, i) in searchCourses"
          :key="i"
          class="w-full sm:w-1/2 md:w-1/3 flex my-2"
        >
          <course-card :course="course" class="flex w-full" />
        </div>
        <empty
          v-if="!searchCourses.length > 0"
          message="courses could not be found"
        />
      </div>
      <div class="flex flex-wrap" v-if="selection === 'drafted'">
        <div
          v-for="(course, i) in searchDrafted"
          :key="i"
          class="w-full sm:w-1/2 md:w-1/3 flex my-2"
        >
          <course-card :course="course" class="flex w-full" />
        </div>
        <empty
          v-if="!searchDrafted.length > 0"
          message="Drafted Courses could not be found"
        />
      </div>
    </lcontainer>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Empty from "../../../components/general/Empty";
export default {
  components: {
    Empty,
    CourseCard: () => import("@/components/tenant/course-card"),
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    LmsTable: () => import("@/components/admin/admin-table"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    linput: () => import("@/components/general/input"),
  },
  data() {
    return {
      form: {},
      error: {},
      search: "",
      selection: "published",
      sort: [
        { text: "Name", value: "Name" },
        { text: "Email", value: "Email" },
      ],
      filter: [
        { text: "Tenants assigned to me", value: "Tenants assigned to me" },
        { text: "All Tenants", value: "All Tenants" },
      ],
    };
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions([
      "fetchTenantCourses",
      "deleteTenantCourse",
      "fetchTenantDraftedCourses",
      //"getTenantPrograms"
    ]),
    loadData() {
      this.updateLoader(true);
      this.fetchTenantCourses({ user: this.getUser });
      this.fetchTenantDraftedCourses({ user: this.getUser });
      this.updateLoader(false);
    },
    // getPrograms() {
    //     let programs = this.getTenantPrograms;
    //     console.log(programs);
    //     return programs;
    // },
    // getSpecificProgram(id) {
    //     let programs = this.getTenantPrograms;
    //     let sortedPrograms = [];
    //     for (let i = 0; i < programs.length; i++) {
    //         let temp = {
    //             text: programs[i].title,
    //             value: programs[i].id,
    //         };
    //         sortedPrograms = sortedPrograms.concat(temp);
    //     }
    //     return sortedPrograms;
    // },
  },
  computed: {
    ...mapGetters(["getTenantCourses", "getUser", "getTenantDraftedCourses"]),
    searchCourses() {
      return this.getTenantCourses.filter((course) => {
        return course.title.toLowerCase().match(this.search.toLowerCase());
      });
    },
    searchDrafted() {
      return this.getTenantDraftedCourses.filter((course) => {
        return course.title.toLowerCase().match(this.search.toLowerCase());
      });
    },

  },
  mounted() {
    this.$Bus.$on("fetch-courses", (data) => {
      this.loadData();
    });
    this.loadData();
    //this.getPrograms();
  },
};
</script>
<style scoped></style>
